module.exports = __webpack_public_path__ + "cloudDevices_smallDesktop.png";